'use strict';
var _ = require('lodash');
var $ = require('jquery');
var Backbone = require('backbone');
var PubSub = require('tscom-pubsub');
var template = require('../../templates/votegrid.ejs');
var VoteOptionView = require('./voteoption');
module.exports = Backbone.View.extend({
    className: 'view-votegrid',

    contestantsViews: [],

    /**
     * Initialize Vote Grid View
     */
    initialize: function (options) {
        _.bindAll(this, 'render', 'scrollEvent', 'submitVotes');

        this.contestantsViews = [];
        this.optionsList = options.optionsList;
        this.userModel = options.userModel;
        this.votes = this.optionsList.getTotal();
        this.maxVotes = this.optionsList.maxVotes;
        this.countdownView = options.countdownView;
        this.countdownRendered = this.countdownView.render().$el;
        this.cms = options.cms;
        this.copyCms = options.copyCms;
        this.model = this.copyCms.get('text').views_vote_grid;
        this.headerStuck = false;
        this.headerId = 'TelescopeHeader'+_.uniqueId(Math.floor((Math.random())*100));

        this.listenTo(this.copyCms, 'change:language', function() {
            this.model = this.copyCms.get('text').views_vote_grid;
            this.contestantsViews.forEach( function(view) {
                view.undelegateEvents();
                view.$el.detach();
            });

            this.render();
            this.renderedToDOM();

            this.contestantsViews.forEach( function(view) {
                view.delegateEvents();
            });
        });

        this.createShareHeader = options.createShareHeader;
    },
    /**
     * Render Vote Grid View
     */
    render: function () {
        var model = _.clone(this.model);
        model.votes_text = this.getRemainingVotes();
        model.headerId = this.headerId;
        model.submit_text = this.optionsList.getTotal() > 0? model.change : model.submit;

        this.$el.html(template( model ));


        this.$('.cd-wrapper').html(this.countdownRendered);

        $('#skip-to-contestants').eq(0).show();

        this.addListeners();
        this.addContestants();

        this.createShareHeader( this.$el.find( '.sticky-share' ));

        return this;
    },
    /**
     * [addListeners description]
     */
    addListeners: function() {
        $(window).off('scroll',this.scrollEvent);
        $('.page-wrapper .content').off('scroll',this.scrollEvent);
        $('.page-wrapper').off('scroll',this.scrollEvent);

        $(window).on('scroll',this.scrollEvent);
        $('.page-wrapper .content').on('scroll',this.scrollEvent);
        $('.page-wrapper').on('scroll',this.scrollEvent);
    },
    /**
     * [addContestants description]
     */
    addContestants: function() {
        var elms = [];

        if( this.contestantsViews.length === 0 ) {
            var models = this.optionsList.models;
            models.sort(function(a,b){
                if(a.get('name') > b.get('name')) {
                    return 1;
                } else if(a.get('name') < b.get('name')) {
                    return -1;
                } else {
                    return 0;
                }
            });
            _.each(models, function(value) {
                value.set('saved', false);
                this.listenTo(value, 'change:voteCount', this.voteCountUpdate);
                var contestant = new VoteOptionView({
                    model: value,
                    optionsList: this.optionsList,
                    userModel: this.userModel,
                    copyCms: this.copyCms
                }).render();

                this.contestantsViews.push(contestant);
                elms.push( contestant.$el );

            }.bind(this));
        } else {
            this.contestantsViews.forEach( function(view) {
                elms.push( view.$el );
            });
        }

        this.$('.contestants').prepend(elms);
        this.$('.contestants').addClass('contestants-'+this.optionsList.models.length);
    },
    /**
     * [getRemainingVotes description]
     * @return {[type]} [description]
     */
    getRemainingVotes: function() {
        this.votes = this.maxVotes - this.optionsList.getTotal();
        var votesWord = (this.votes === 1) ? this.model.vote : this.model.votes;
        return this.model.votes_text.replace('{{VOTES}}', '<span class="votes">'+this.votes+' '+votesWord+'</span>');
    },
    /**
     * [voteCountUpdate description]
     * @param  {[type]} model     [description]
     * @param  {[type]} voteCount [description]
     * @return {[type]}           [description]
     */
    voteCountUpdate: function() {
        var votesAllocated = this.optionsList.getTotal();
        var hasRemainingVotes = votesAllocated <= this.maxVotes;

        $('#'+this.headerId+' h2').html(this.getRemainingVotes());
        
        if(hasRemainingVotes && this.optionsList.hasChangedVotes()) {
            $('#skip-to-save').eq(0).show();
            $('#' + this.headerId + ' .submit').attr({
                'aria-disabled': false,
                'aria-label': this.model.save_votes_a11y
            });
        
        } else {
            $('#skip-to-save').eq(0).hide();
            $('#' + this.headerId + ' .submit').attr({
                'aria-disabled': true,
                'aria-label': this.model.save_votes_a11y
            });
        } 
    },
    /**
     * [submitVotes description]
     * @param  {[type]} e [description]
     * @return {[type]}   [description]
     */
    submitVotes: function(e) {
        if (e.target.getAttribute('aria-disabled') === 'true') {
            return false;
        }

        //DV-971 safari does not automatically grant focus to buttons, even after clicking
        e.target.focus();

        if(!this.userModel.isConnected()) {
            //this.trigger('launchLogin', {});
            PubSub.trigger('launchLogin', this.submitVotes.bind(this));
        } else if(this.userModel.isConnected()) {
            //scroll up and let the scroll function handle moving the header
            this.trigger('scrollTop',{});

            //debounce to allow the scroll to happen first
            window.setTimeout(function(){
                PubSub.trigger('omniture:action','voteEditClick','Save Votes');
                this.trigger('submitVotes', {});
            }.bind(this),100);

        }
    },
    /**
     * [scrollEvent description]
     * @return {[type]} [description]
     */
    scrollEvent: function() {
        var submitContainerPos = this.$('.submit-container').offset().top - $(window).scrollTop() - 24; // the -24 is for padding
        if (submitContainerPos <= 0) {
            this.$('.submit-container .outer').addClass('fixed');
            if(this.countdownRendered[0].innerHTML.trim().length > 0) {
                this.$('.cd-wrapper').addClass('fixed');
            }
            if(this.$('.submit-container .outer').text()) {
                $('#'+this.headerId+' .submit').off('click',this.submitVotes);
                $('#TelescopeAppDWTSModal').html(this.$('.submit-container .outer'));
                $('.sticky-countdown').html(this.countdownRendered);
                $('#'+this.headerId+' .submit').on('click',this.submitVotes);
                this.headerStuck = true;
            }
        } else {
            if($('#TelescopeAppDWTSModal .outer').text()) {
                $('#'+this.headerId+' .submit').off('click',this.submitVotes);
                this.$('.submit-container').html($('#TelescopeAppDWTSModal .outer'));
                $('.sticky-countdown').empty();
                this.$('.cd-wrapper').html(this.countdownRendered);
                $('#'+this.headerId+' .submit').on('click',this.submitVotes);
                this.headerStuck = false;
            }
            this.$('.cd-wrapper.fixed').removeClass('fixed');
            this.$('.submit-container .outer').removeClass('fixed');
        }
    },
    /**
     * [renderedToDOM description]
     * @return {[type]} [description]
     */
    renderedToDOM: function() {
        //this.setCollectiveHeight();
        $('#'+this.headerId+' .submit').off('click',this.submitVotes);
        $('#'+this.headerId+' .submit').on('click',this.submitVotes);


        if(this.optionsList.getTotal() <= this.maxVotes && this.optionsList.hasChangedVotes()) {
            this.$('.submit').attr('aria-disabled',false);
        }
    },
    /**
     * [setCollectiveHeight description]
     */
    setCollectiveHeight: function(){

        var height = 0;
        this.$('.section').each(function() {
            if($(this).outerHeight() > height){
                height = $(this).outerHeight();
                var item = $('.section');
                item.removeAttr('style');
                item.css('height', $(this).outerHeight() + 'px');
            }
        });
    },
    /**
     * [checkNameSizes description]
     * @return {[type]} [description]
     */
    checkNameSizes: function() {
        this.$('.name-container').each(function() {
            var $nameContainer = $(this);
            var $nameText = $nameContainer.find( '.name-text' );
            $nameContainer.css( 'width', $nameContainer.width() - 185 + 'px' );

            var font = parseInt( $nameText.css('font-size') );
            while( $nameContainer.width() + 10 <= $nameText.width() && font > 10 )
            {
                font--;
                $nameText.css('font-size', font+'px');
            }
        });
    },
    /**
     * [remove description]
     * @return {[type]} [description]
     */
    remove: function() {
        $('.page-wrapper .content').off('scroll');
        $('.page-wrapper').off('scroll');
        $(window).off('scroll');
        $('#'+this.headerId+' .submit').off('click');

        $('#skip-to-save').hide();
        $('#skip-to-contestants').hide();
        this.contestantsViews.forEach( function(view) {
            view.remove();
        });
        this.contestantsViews = [];
        this.countdownView.remove();
        //get rid of sticky header
        $('#TelescopeAppDWTSModal .outer').html('');

        Backbone.View.prototype.remove.call(this);
    }
});



// WEBPACK FOOTER //
// ./app/scripts/common/views/votegrid.js